// Feedback & Reports event definitions — emitted from the feedback modal and
// its call sites. See `frontend/docs/feedback-modal.html` (Plan § crosscut).

import type { FeedbackIntent, FeedbackSource, FeedbackType } from '@/config/feedback';
import type { EventDefinition } from './navigation';

export type FeedbackOpenedProperties = {
  source: FeedbackSource;
  intent: FeedbackIntent;
};

export type FeedbackSubmittedProperties = {
  type: FeedbackType;
  surface: string;
};

export const FEEDBACK_OPENED: EventDefinition<FeedbackOpenedProperties> = {
  name: 'feedback_opened',
};

export const FEEDBACK_SUBMITTED: EventDefinition<FeedbackSubmittedProperties> = {
  name: 'feedback_submitted',
};
